import React, { createContext, useContext, useState } from 'react';

const NotifContext = createContext();

const INIT = [
  { id:1, type:'lead',    text:'New lead Anand Kumar added',         time:'2 min ago',  read:false },
  { id:2, type:'invoice', text:'Invoice INV-002 marked as pending',   time:'1 hr ago',   read:false },
  { id:3, type:'project', text:'Project "Meta Ads Campaign" updated', time:'3 hrs ago',  read:true  },
  { id:4, type:'team',    text:'Meera Nair marked attendance',        time:'Today 9am',  read:true  },
  { id:5, type:'reminder',text:'Follow-up: Deepak Singh due today',   time:'Today',      read:false },
  { id:6, type:'lead',    text:'Lead Rajesh Nair moved to Warm',      time:'Yesterday',  read:true  },
  { id:7, type:'reminder',text:'Invoice INV-005 is overdue',          time:'2 days ago', read:false },
];

export function NotifProvider({ children }) {
  const [notifs, setNotifs] = useState(INIT);
  const markRead  = (id) => setNotifs(n => n.map(x => x.id===id ? {...x,read:true} : x));
  const markAll   = ()   => setNotifs(n => n.map(x => ({...x,read:true})));
  const unread    = notifs.filter(n => !n.read).length;
  return <NotifContext.Provider value={{ notifs, markRead, markAll, unread }}>{children}</NotifContext.Provider>;
}

export const useNotif = () => useContext(NotifContext);
